import { Icon } from '@iconify/react';
import React from 'react';

const Social = () => {
  return (
    <ul className="st-social-btn st-style1 st-mp0">
      <li>
        <a href="https://www.instagram.com/fisioters_sas/" target="_blank" rel="noopener noreferrer">
          <Icon icon="fa6-brands:instagram" />
        </a>
      </li>
      <li>
        <a href="https://wa.me/573008271686" target="_blank" rel="noopener noreferrer">
          <Icon icon="fa6-brands:whatsapp" />
        </a>
      </li>
    </ul>
  );
};

export default Social;

